import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register as registerSwiperElements } from 'swiper/element/bundle';

// Save original method
// const originalAddEventListener = EventTarget.prototype.addEventListener;

// // Override
// EventTarget.prototype.addEventListener = function (
//   type: string,
//   listener: EventListenerOrEventListenerObject,
//   options?: boolean | AddEventListenerOptions
// ) {
//   // Force passive: false for specific events
//   const needsPassiveFalse = ['touchstart', 'touchmove', 'wheel'].includes(type);

//   if (needsPassiveFalse) {
//     if (typeof options === 'boolean' || options === undefined) {
//       options = { passive: false };
//     } else if (typeof options === 'object') {
//       options.passive = false;
//     }
//   }

//   return originalAddEventListener.call(this, type, listener, options);
// };

registerSwiperElements();

// Enable horizontal scroll with mouse wheel for custom-scrollbar elements and AG-Grid
// This allows scrolling horizontally when using the mouse wheel on elements with overflow-x
// Implements nested scroll: when child horizontal scroll reaches limit, parent vertical scroll takes over
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    let isScrolling = false;
    let scrollTimeout: any = null;

    // Use event delegation for better performance
    document.addEventListener('wheel', (e: WheelEvent) => {
      const target = e.target as HTMLElement;
      
      // Find if the target or any parent has custom-scrollbar class
      const scrollElement = target.closest('.custom-scrollbar') as HTMLElement;
      
      if (scrollElement) {
        // For AG-Grid, find the actual scrollable viewport
        let actualScrollElement = scrollElement;
        
        // Check if this is an AG-Grid container
        if (scrollElement.classList.contains('ag-theme-grid') || scrollElement.classList.contains('ag-theme-quartz')) {
          // Try to find the AG-Grid body viewport (the actual scrollable element)
          const agCenter = scrollElement.querySelector('.ag-center-cols-viewport') as HTMLElement;
          if (agCenter) {
            actualScrollElement = agCenter;
          }
        }
        
        const hasHorizontalScroll = actualScrollElement.scrollWidth > actualScrollElement.clientWidth;
        const hasVerticalScroll = actualScrollElement.scrollHeight > actualScrollElement.clientHeight;
        
        // If has horizontal scroll and no vertical scroll, or shift key is pressed
        if (hasHorizontalScroll && (!hasVerticalScroll || e.shiftKey)) {
          // Check if we're at horizontal scroll limits
          const isAtLeftEdge = actualScrollElement.scrollLeft <= 0;
          const isAtRightEdge = actualScrollElement.scrollLeft + actualScrollElement.clientWidth >= actualScrollElement.scrollWidth - 1;
          
          // Determine scroll direction (positive = right/down, negative = left/up)
          const scrollingRight = e.deltaY > 0;
          const scrollingLeft = e.deltaY < 0;
          
          // Allow parent scroll when at edge and scrolling in that direction (nested scroll behavior)
          const shouldAllowParentScroll = (isAtLeftEdge && scrollingLeft) || (isAtRightEdge && scrollingRight);
          
          // Only prevent default and scroll horizontally if we're not at a limit
          if (!shouldAllowParentScroll) {
            e.preventDefault();
            
            // Prevent text selection during scroll
            if (!isScrolling) {
              isScrolling = true;
              document.body.style.userSelect = 'none';
              scrollElement.style.userSelect = 'none';
            }
            
            // Clear previous timeout
            if (scrollTimeout) {
              clearTimeout(scrollTimeout);
            }
            
            // Perform the scroll
            actualScrollElement.scrollLeft += e.deltaY;
            
            // Re-enable text selection after scrolling stops
            scrollTimeout = setTimeout(() => {
              isScrolling = false;
              document.body.style.userSelect = '';
              scrollElement.style.userSelect = '';
            }, 150);
          }
        }
      }
    }, { passive: false });
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
